import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "truncate pr-7" }
const _hoisted_3 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle(`width: ${_ctx.width}`),
    class: "overflow-hidden bg-white rounded-md shadow-sm"
  }, [
    _createElementVNode("button", {
      class: "flex items-center w-full px-2 py-2.5 relative",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleCardClick && _ctx.handleCardClick(...args)))
    }, [
      _createElementVNode("img", {
        src: _ctx.icon,
        class: "object-contain w-6 h-6 flex-shrink-0 mr-2",
        alt: ""
      }, null, 8, _hoisted_1),
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.text), 1),
      _createElementVNode("button", {
        class: "absolute right-2 focus:outline-none focus:ring-2 focus:ring-blue-300 rounded-full",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleDownloadClick && _ctx.handleDownloadClick(...args))),
        "aria-label": "Download"
      }, [
        _createElementVNode("div", {
          class: "w-5 h-5 object-contain",
          innerHTML: _ctx.DOWNLOAD_ICON
        }, null, 8, _hoisted_3)
      ])
    ])
  ], 4))
}